module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "chaptitler-a"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sumeria")])]), _vm._v(" "), _c('h3', {
    staticClass: "chaptitle1-a2",
    attrs: {
      "id": "ch2-3"
    }
  }, [_vm._v("LIPIT-ISTAR’S LAW, 2207 B.C."), _c('a', {
    attrs: {
      "href": "#/xhtml/12_Chapter023#rch2fnc",
      "id": "ch2fnc"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-as"
  }, [_vm._v("Lipit-istar, King of Isin, recently was discovered to be the author of a collection of Sumerian laws and is thought to be the author of a section of laws written in the old Babylonian dialect and not thoroughly unrelated to the laws of Hammurabi. In fact, the reader will note that the text agrees almost word for word with section seven of the laws of Hammurabi.")]), _vm._v(" "), _c('p', {
    staticClass: "center-att"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("A")])]), _vm._v(" "), _c('p', {
    staticClass: "center-a"
  }, [_vm._v("§1")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If a son says to his father ‘Thou art not my father,’ he may shave him, he may put the slave-mark on him [and] sell him.")]), _vm._v(" "), _c('p', {
    staticClass: "center-att"
  }, [_vm._v("§2")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If a (!) son says to his mother ‘Thou art not my mother,’ they shall shave half his head and lead him round the city and put him out of the house.")]), _vm._v(" "), _c('p', {
    staticClass: "center-att"
  }, [_vm._v("§3")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If a father says to his son ‘Thou art not my son,’ he forfeits house and wall.")]), _vm._v(" "), _c('p', {
    staticClass: "center-att"
  }, [_vm._v("§4")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If a mother says to her (!) son ‘Thou art not my son,’ she forfeits house and furniture.")]), _vm._v(" "), _c('p', {
    staticClass: "center-att"
  }, [_vm._v("§5")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If a wife has hated her (!) husband and says ‘Thou art not "), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _vm._v("my husband,’ they shall throw her (!) into the river.")]), _vm._v(" "), _c('p', {
    staticClass: "center-att"
  }, [_vm._v("§6")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If a husband says to his wife ‘Thou art not my wife,’ he shall pay ½ maneh of silver by weight.")]), _vm._v(" "), _c('p', {
    staticClass: "center-att"
  }, [_vm._v("§7")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If a man has hired a slave and he has then died (or) escaped (or) fled (or) struck work or fallen sick, he shall pay 1 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ban")]), _vm._v(" of corn by measure as his daily hire.")]), _vm._v(" "), _c('p', {
    staticClass: "center-att"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("B")])]), _vm._v(" "), _c('p', {
    staticClass: "center-a"
  }, [_vm._v("§1")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If he does not pay silver, he shall pay him grain by measure at the current rate.")]), _vm._v(" "), _c('p', {
    staticClass: "center-att"
  }, [_vm._v("§2")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If he will not pay grain, he shall add 10 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("še")]), _vm._v(" on every 1 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("gur")]), _vm._v(" as interest thereon and shall pay … grain [by measure].")]), _vm._v(" "), _c('p', {
    staticClass: "center-att"
  }, [_vm._v("§3")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If he does not pay silver and (the price of) corn falls, at the expiry of the year he shall pay the corn and the interest on it by measure.")]), _vm._v(" "), _c('p', {
    staticClass: "center-att"
  }, [_vm._v("§4")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If he is able (to pay) silver, he shall add 1 maneh 12 shekels in silver as interest.")]), _vm._v(" "), _c('p', {
    staticClass: "center-att"
  }, [_vm._v("§5")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If he does not pay silver, he shall pay 1 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("gur")]), _vm._v(" of corn by measure for every 1 shekel of silver.")]), _vm._v(" "), _c('p', {
    staticClass: "note-a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12_Chapter023#ch2fnc",
      "id": "rch2fnc"
    }
  }, [_vm._v("*")]), _vm._v(" From "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Babylonian Laws")]), _vm._v(", edited by G. R. Driver and John C. Mills, Oxford, Clarendon Press, 1955.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-997367d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/12_Chapter023.vue
// module id = 102
// module chunks = 0